import { Injectable } from '@angular/core';
import { environment } from './../../environments/environment';
import { HttpClient } from '@angular/common/http';
import Pusher from 'pusher-js';

@Injectable({
  providedIn: 'root'
})
export class PusherService {

  pusher: any;
  channel: any;

  constructor(private http: HttpClient) {

    this.pusher = new Pusher(environment.pusher.key, {
      cluster: environment.pusher.cluster
    });

    this.channel = this.pusher.subscribe('tecnogru');

  }

  getChannel(){

    return this.channel;

  }

  /*    
  like( num_likes ) {
    this.http.post('http://localhost:3120/update', {'likes': num_likes})
    .subscribe(data => {});
  } 
  */
}
